import { get } from 'lodash'
import config from '../../../config'
import axios from 'axios'
import toast from 'react-hot-toast'

const apiServerUrl = get(config, 'apiServerUrl')

const getTenantDetails = async (businessIds: number[], tenantId?: number) => {
    try {
        const payload = tenantId ? { tenantId } : { businessIds }
        const response = await axios.post(
            `${apiServerUrl}/admin/subscription/list?`,
            payload
        )
        return response
    } catch (error) {
        console.error(error)

        toast.error(`Error in get Subscription Details`)
    }
}

const getSubscriptionDetails = async (subscriptionId: number) => {
    try {
        const response = await axios.get(
            `${apiServerUrl}/admin/subscription/${subscriptionId}`
        )
        return response
    } catch (error) {
        console.error(error)
        toast.error(`Error fetching Subscription details:`)
    }
}

const stopSubscription = async (
    subscriptionId: number,
    isBillable: boolean,
    stoppedBy: string
) => {
    try {
        const response = await axios.put(
            `${apiServerUrl}/admin/subscription/${subscriptionId}/stop`,
            { isBillable, stoppedBy }
        )
        return response
    } catch (error) {
        console.error(error)
        toast.error(`Error in Stopping subscription`)
    }
}

const stopPackage = async (
    PackageId: number,
    isBillable: boolean,
    stoppedBy: string
) => {
    try {
        const response = await axios.put(
            `${apiServerUrl}/admin/subscription/packages/${PackageId}/stop`,
            { isBillable, stoppedBy }
        )
        return response
    } catch (error) {
        console.error(error)
        toast.error(`Error in Stop packages`)
    }
}


const goLivePackage = async (
    packageId: number,
    updatedBy: string,
    startDate?: string | null
) => {
    try {
        const response = await axios.put(
            `${apiServerUrl}/admin/subscription/packages/${packageId}/go-live`,
            { startDate, updatedBy }
        )
        return response
    } catch (error) {
        console.error(error)
        toast.error(`Error in marking package live`)
    }
}


export {
    getTenantDetails,
    getSubscriptionDetails,
    stopSubscription,
    stopPackage,
    goLivePackage,
}
